const isRecord = (value: unknown): value is Record<string, unknown> =>
  value !== null && typeof value === 'object' && !Array.isArray(value);

const enumName = (value: unknown): unknown =>
  typeof value === 'string' && value.length > 0 ? value[0].toUpperCase() + value.slice(1) : value;

/** Adapts catalog enum names to the existing drawer without changing the API payload. */
export const normalizeGuardRailsChartTypes = <T>(types: T[]): T[] =>
  types.map((type) => {
    if (!isRecord(type)) return type;
    return {
      ...type,
      ...('chartType' in type ? { chartType: enumName(type.chartType) } : {}),
      ...(Array.isArray(type.rules) ? { rules: type.rules.map(enumName) } : {}),
      ...(Array.isArray(type.children)
        ? { children: normalizeGuardRailsChartTypes(type.children) }
        : {}),
      ...(isRecord(type.summary) && 'ruleName' in type.summary
        ? { summary: { ...type.summary, ruleName: enumName(type.summary.ruleName) } }
        : {}),
    };
  });

/** Adapts GetData chart/rule enum names to the existing drawer's PascalCase catalog. */
export const normalizeGuardRailsConfig = <T>(config: T): T => {
  if (!isRecord(config)) return config;
  return {
    ...config,
    ...('chart' in config ? { chart: enumName(config.chart) } : {}),
    ...(Array.isArray(config.rules)
      ? {
          rules: config.rules.map((rule) =>
            isRecord(rule) && 'ruleName' in rule
              ? { ...rule, ruleName: enumName(rule.ruleName) }
              : rule
          ),
        }
      : {}),
  };
};
